export default __webpack_public_path__ + "static/avatar4-e5b8412b15199c67be7978ded2be72e3.png";